// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
// require("turbolinks").start()
// require("@rails/activestorage").start()
require("channels")

require('components/animations.js')
require('components/autoscroll.js')
require('components/quote-request.js')
require('components/sliders.js')


import CSSPlugin from 'gsap/CSSPlugin';
import { gsap, Power4, TimelineLite }  from "gsap"; // Also works with TweenLite and TimelineLite
const myPlugins = [CSSPlugin]

import LazyLoad from "vanilla-lazyload";
import Intersection from 'components/intersection'

const FADEINTIME = 1;

document.addEventListener('DOMContentLoaded', ()=> {
	/////////////////////////////
	/// PAGE FADEIN ANIMATION ///
	/////////////////////////////
	gsap.to(['body','html'], FADEINTIME, {opacity: 1, ease: Power4.easeInOut} )

	////////////////////
	/// HOME STAG-IN ///
	////////////////////
	if(document.querySelector('.pages-home')){
		document.querySelector('.header_logo').classList.add('stagger-fade-in')
		document.querySelectorAll('.header_nav_item').forEach(i => i.classList.add('stagger-fade-in'))
		document.querySelectorAll('.header_buttons a').forEach(i => i.classList.add('stagger-fade-in'))
		document.querySelector('.big-slider_item_body').classList.add('stagger-fade-in')
		document.querySelectorAll('.footer_inner_item').forEach(i => i.classList.add('stagger-fade-in'))
		// document.querySelectorAll('.big-slider_item_image').forEach(i => i.classList.add('simple-fade-in'))
		let tl = new TimelineLite()
		tl.staggerFromTo('.stagger-fade-in', 0.5, {opacity: 0}, {opacity: 1}, 0.08, 1)
		tl.fromTo('.big-slider_item_image', 0.5, {opacity: 0}, {opacity: 1})
	}
	////////////////
	/// LAZYLOAD ///
	////////////////
	let lazyLoadInstance = new LazyLoad({});

	///////////////////
	/// TEXT FADEIN ///
	///////////////////
	let elements = document.querySelectorAll('[data-fade]')

		if (elements) {
			elements.forEach((el) => {
				gsap.set(el, { y: 20, opacity: 0 })
			})
	}
	Intersection()

	/////////////
	/// POPUP ///
	/////////////
	let popupCloseBtns = document.querySelectorAll('.js-popup-close')
	popupCloseBtns.forEach(i => {
		i.addEventListener('click', () => {
			document.querySelectorAll('.popup').forEach(i => i.classList.remove('is-active'))
			document.querySelector('body, html').classList.remove('noscroll')
		})
	})

	///////////////////
	/// MENU MOBILE ///
	///////////////////

	let hamburger = document.querySelector('button.hamburger')
	let menuMobile = document.querySelector('.header_nav')
	let btnsMobile = document.querySelector('.header_buttons')
    if (hamburger != null){
        hamburger.addEventListener('click', () => {
            hamburger.classList.toggle('is-active')
            menuMobile.classList.toggle('is-active')
            btnsMobile.classList.toggle('is-active')
            document.querySelector('html, body').classList.toggle('noscroll')
        })
    }
	

	let openSubMob = document.querySelector('.js-open-sub-mobile')
     if (openSubMob != null){
        	openSubMob.addEventListener('click',  () => {
        		openSubMob.classList.toggle('is-active')
        		openSubMob.querySelector('.header_nav_item_sub-mobile').classList.toggle('is-active')
        	})
        }

	// in caso allargassi vieport con menu aperto devo riattivare lo scroll
	window.addEventListener('resize', () => {
		if(window.innerWidth < 900 && document.querySelector('html').classList.contains('noscroll')){
			document.querySelector('html').classList.remove('noscroll')
		}
	})

	/////////////////////////
	//// SAFARI DETECTOR ////
	/////////////////////////
	var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
	if (isSafari) { 
	  document.querySelector('body').classList.add('is-safari')
	};

})
